import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales/ETLCodes";
import { useTl } from "../../hooks";
import { Intent, Button } from "@blueprintjs/core";
import { ICustomButtonProps } from "./ICustomButtonProps";

export interface IDuplicateButtonProps extends ICustomButtonProps {}

export const DuplicateButton: React.FunctionComponent<IDuplicateButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.DUPLICATE}
      minimal={minimal}
      onClick={onClick}
      text={minimal ? null : t(ETLCodes.Duplicate)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={onClick ? "button" : "submit"}
    />
  );
};
